"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const translate_1 = require("components/translate");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const publish_1 = require("modules/app/services/datahub/publish");
const contentPublishModal_module_scss_1 = __importDefault(require("./contentPublishModal.module.scss"));
const PublishQuicklyModal = ({ t, isMobile, onClose, onPublish }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handlePublish = async () => {
        setIsLoading(true);
        await onPublish();
        publish_1.DatahubPublishService.publish();
        setIsLoading(false);
    };
    const handleClose = () => {
        publish_1.DatahubPublishService.cancel();
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { show: true, onClose: onClose, className: contentPublishModal_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { className: "_text-4 _text-gray-900 _font-weight-bold", children: t('page_content.publish_modal.title') }), (0, jsx_runtime_1.jsx)(modal_1.Modal.Body, { className: "_pt-0", children: t('page_content.publish_modal.description') }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _flex-column _flex-lg-row _justify-content-end", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "secondary", className: "_mr-lg-3", ...(isMobile && { size: 'block' }), onClick: handleClose, children: t('page_content.publish_modal.actions.publish_later') }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", loading: isLoading, disabled: isLoading, onClick: handlePublish, ...(isMobile && { size: 'block' }), children: t('page_content.publish_modal.actions.publish_now') })] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(({ UiStore }) => ({
    isMobile: UiStore.isMobile
})))(PublishQuicklyModal);
